import { publicInvitationService } from './publicInvitationService';
import { resendService } from '../resendService';
import { createLogger } from '../logger';

const notificationLog = createLogger('notification');

export const notificationService = {
  async sendTableNotification(params: {
    guestName: string;
    guestEmail: string;
    tableName: string;
    inviteCode: string;
    weddingDate?: string;
    weddingTime?: string;
    venue?: string;
    brideName?: string;
    groomName?: string;
  }): Promise<void> {
    notificationLog.debug('發送桌號通知', params.guestName, params.tableName);

    try {
      let invitationDetails = null;
      if (!params.weddingDate || !params.brideName || !params.groomName) {
        invitationDetails = await publicInvitationService.getInvitationByCode(params.inviteCode);
      }

      const brideName = params.brideName || invitationDetails?.brideName || '';
      const groomName = params.groomName || invitationDetails?.groomName || '';
      const subject = `${brideName} & ${groomName} 婚禮座位安排通知 | Wedding Seating Info`;

      const emailHtml = resendService.createTableNotificationHtml({
        guestName: params.guestName,
        tableName: params.tableName,
        brideName,
        groomName,
        weddingDate: params.weddingDate || invitationDetails?.weddingDate,
        weddingTime: params.weddingTime || invitationDetails?.weddingTime,
        welcomePartyTime: invitationDetails?.welcomePartyTime,
        ceremonyTime: invitationDetails?.ceremonyTime,
        receptionTime: invitationDetails?.receptionTime,
        venue: params.venue || invitationDetails?.venue,
        address: invitationDetails?.address,
        mapUrl: invitationDetails?.mapUrl,
      });

      const result = await resendService.sendEmail({
        to: params.guestEmail,
        subject,
        html: emailHtml,
      });

      if (!result.success) {
        throw new Error(result.error || '發送失敗');
      }

      notificationLog.info('桌號通知發送成功:', result.messageId);

    } catch (error) {
      notificationLog.error('發送桌號通知失敗:', error);
      throw new Error(`發送桌號通知失敗: ${error instanceof Error ? error.message : '未知錯誤'}`);
    }
  },

  async sendBatchTableNotifications(notifications: Array<{
    guestName: string;
    guestEmail: string;
    tableName: string;
    inviteCode: string;
  }>): Promise<{ success: number; failed: number; errors: string[] }> {
    notificationLog.debug('批量發送桌號通知', notifications.length, '位賓客');

    let successCount = 0;
    let failedCount = 0;
    const errors: string[] = [];

    let invitationDetails = null;
    if (notifications.length > 0) {
      try {
        invitationDetails = await publicInvitationService.getInvitationByCode(notifications[0].inviteCode);
      } catch (error) {
        notificationLog.warn('無法獲取邀請函詳細資訊:', error);
      }
    }

    for (const notification of notifications) {
      try {
        await this.sendTableNotification({
          ...notification,
          weddingDate: invitationDetails?.weddingDate,
          weddingTime: invitationDetails?.weddingTime,
          venue: invitationDetails?.venue,
          brideName: invitationDetails?.brideName,
          groomName: invitationDetails?.groomName,
        });

        successCount++;

        await new Promise(resolve => setTimeout(resolve, 500));

      } catch (error) {
        failedCount++;
        const errorMessage = `${notification.guestName} (${notification.guestEmail}): ${error instanceof Error ? error.message : '未知錯誤'}`;
        errors.push(errorMessage);
        notificationLog.error('批量發送失敗:', errorMessage);
      }
    }

    notificationLog.info('批量發送完成: 成功', successCount, '失敗', failedCount);

    return {
      success: successCount,
      failed: failedCount,
      errors
    };
  }
};
